import { render, staticRenderFns } from "./FieldMetricPoints.vue?vue&type=template&id=1f166c66&"
import script from "./FieldMetricPoints.vue?vue&type=script&lang=ts&"
export * from "./FieldMetricPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports